import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import posthog from 'posthog-js';
import Clarity from '@microsoft/clarity';
import App from './App.jsx'
import "../sentry.client.config.js";
import { AuthProvider } from './auth/AuthProvider.jsx';


// Initialize PostHog once
if (import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || "https://app.posthog.com",
    capture_pageview: false, // IMPORTANT for React Router
    capture_pageleave: true,
  });
}

// Initialize Microsoft Clarity once
if (import.meta.env.VITE_CLARITY_PROJECT_ID) {
  Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID);
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

            